import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';

import { faLink, faLinkSlash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import useRemoteBoundStore from 'src/store/useRemoteBoundStore';

import { useGetCurrentCaptureProcess } from 'src/hooks/camera/useGetCurrentCaptureProcess';
import useUiTranslation from 'src/hooks/useUiTranslation';

const CameraConnectivity = () => {
  const { error } = useGetCurrentCaptureProcess();
  const { cameraData } = useRemoteBoundStore();

  const { tPages } = useUiTranslation();
  return (
    <OverlayTrigger
      placement="right"
      delay={{ show: 250, hide: 400 }}
      overlay={<Tooltip>{tPages('header.cameraIp')}</Tooltip>}
    >
      <Button variant={error ? 'danger' : 'primary'}>
        <FontAwesomeIcon icon={error ? faLinkSlash : faLink} className="me-2" />
        {cameraData?.ip}
      </Button>
    </OverlayTrigger>
  );
};

export default CameraConnectivity;
